var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('client-info',{attrs:{"id":_vm.order['client']['id'],"button_key":"next_step"},on:{"input":_vm.send}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }